import { Card, Container, Image, Spinner } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
//
import EditIcon from '../../assets/icons/edit.svg'
import { useLanguage } from '../../context/LanguageContext'
import { GET_INFO } from '../../config'

export default function PrizeGivingInfo() {
  const [info, setInfo] = useState({})
  const { language } = useLanguage()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState()

  const navigate = useNavigate()

  useEffect(() => {
    const token = localStorage.getItem('authToken')
    if (token) {
      getPrizeGivingInfo(token)
    }
  }, [])

  const getPrizeGivingInfo = async (token) => {
    setIsLoading(true)
    try {
      const response = await fetch(GET_INFO, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      const res = await response.json()
      if (res.success) {
        if (res?.data?.full_name) {
          setInfo(res?.data)
        } else {
          navigate('/prize-form', { replace: true, state: { data: res?.data } })
        }
      }
    } catch (error) {
      setIsError(error)
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }
  if (isError) {
    return (
      <h5 className='px-4 vh-100 d-flex align-items-center justify-content-center text-secondary'>
        {language.we_are_working_on_it}
      </h5>
    )
  } else if (isLoading) {
    return (
      <h5 className='vh-100 d-flex align-items-center justify-content-center text-secondary'>
        <Spinner variant='success' style={{ borderWidth: 3 }} />
      </h5>
    )
  }
  return (
    <Container
      className='px-4 vh-100 flex-column d-flex overflow-auto'
      style={{ maxWidth: '768px' }}
    >
      <Card border='0' style={{ backgroundColor: '#F2F2F2' }} className='mt-3'>
        <Card.Body className='d-flex justify-content-between align-items-start'>
          <div className='d-flex flex-column gap-2'>
            <div>{info?.full_name}</div>
            <div>{info?.contact_number}</div>
            {info?.shirt_size && (
              <div>
                {language.shirt_size}: {info?.shirt_size}
              </div>
            )}
            <div>
              {[info?.police_station, info?.district]
                .filter((item) => item)
                .join(', ')}
            </div>
            <div>{info?.delivery_address}</div>
          </div>
          <EditButton info={info} />
        </Card.Body>
      </Card>
    </Container>
  )
}

export function EditButton({ info }) {
  const navigate = useNavigate()
  const [opacity, setOpacity] = useState(1)

  const onButtonClick = () => {
    setTimeout(() => {
      setOpacity((prevValue) => {
        if (prevValue === 1) {
          return prevValue
        } else return 0.8
      })
    }, 100)

    navigate('/prize-form', { state: { data: info } })
  }

  return (
    <button
      className='border-0'
      onClick={onButtonClick}
      onMouseEnter={() => setOpacity(0.8)}
      onMouseDown={() => setOpacity(0.9)}
      onMouseLeave={() => setOpacity(1)}
      style={{
        height: 40,
        width: 40,
        borderRadius: '100%',
        opacity: opacity,
        backgroundColor: opacity === 1 ? 'transparent' : '#E6F7E7',
        marginRight: -10,
        marginTop: -10,
      }}
    >
      <Image src={EditIcon} />
    </button>
  )
}
